export const TABLET_BREAKPOINT = 1124;
export const MOBILE_BREAKPOINT = 750;
